import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Restart16 from '@carbon/icons-react/es/restart/16';
import { faExclamationTriangle } from '@fortawesome/pro-duotone-svg-icons/faExclamationTriangle';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Container, EmptyState, EmptyStateContainer as EmptyStateContainerAtom, EmptyStateIcon } from 'components/atoms/empty-state';
import { ROCKETLANE_EMAILS, RoutePaths } from 'constant';
import { useTranslation } from 'hooks/use-translation';
const EmptyStateContainer = styled(EmptyStateContainerAtom)`
  && {
    padding: var(--spacing-12);
  }
  ${Container} {
    width: auto;
    max-width: max-content;
  }
`;
const ErrorInfo = styled.div`
  margin-bottom: var(--spacing-06);
`;
const supportEmail = ROCKETLANE_EMAILS.support;
const domainName = window.location.hostname;
const OktaTimeJWTErrors = [
    'The JWT was issued in the future',
    'The JWT expired and is no longer valid'
];
const EmailNotPresent = [
    'User creation was disabled.',
    'User is not assigned to the client application.',
    'api key creation failed'
];
export const CallbackErrorPage = ({ error })=>{
    const mailSubject = useTranslation('okta.callback_error.email.subject', {
        domainName
    });
    const mailContent = useTranslation('okta.callback_error.email.content', {
        domainName
    });
    const ErrorMessage = OktaTimeJWTErrors.includes(error.message) ? /*#__PURE__*/ _jsx(FormattedMessage, {
        id: "okta.callback_error.info_timezone"
    }) : /*#__PURE__*/ _jsx(FormattedMessage, {
        id: "okta.callback_error.info"
    });
    const ErrorTitle = EmailNotPresent.includes(error.message) ? /*#__PURE__*/ _jsx(FormattedMessage, {
        id: "okta.callback_error_email.not.found"
    }) : /*#__PURE__*/ _jsx(FormattedMessage, {
        id: "okta.callback_error.title"
    });
    return /*#__PURE__*/ _jsx(EmptyStateContainer, {
        $transparent: true,
        children: /*#__PURE__*/ _jsx(EmptyState, {
            image: /*#__PURE__*/ _jsx(EmptyStateIcon, {
                icon: faExclamationTriangle
            }),
            title: ErrorTitle,
            message: !EmailNotPresent.includes(error.message) && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsxs(ErrorInfo, {
                        children: [
                            /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "failure"
                            }),
                            " : ",
                            error.message
                        ]
                    }),
                    ErrorMessage
                ]
            }),
            primaryCTA: /*#__PURE__*/ _jsx("a", {
                href: RoutePaths.login,
                children: /*#__PURE__*/ _jsx(EmptyState.CallToAction.Primary, {
                    leftIcon: /*#__PURE__*/ _jsx(Restart16, {}),
                    children: !EmailNotPresent.includes(error.message) ? /*#__PURE__*/ _jsx(FormattedMessage, {
                        id: "okta.callback_error.cta"
                    }) : /*#__PURE__*/ _jsx(FormattedMessage, {
                        id: "okta.callback_error.cta.different_id.error"
                    })
                })
            }),
            secondaryCTA: /*#__PURE__*/ _jsx(FormattedMessage, {
                id: "okta.callback_error.info_extra",
                values: {
                    link: /*#__PURE__*/ _jsx("a", {
                        target: "_blank",
                        href: `mailto:${supportEmail}?subject=${mailSubject}&body=${mailContent}`,
                        rel: "noreferrer",
                        children: supportEmail
                    })
                }
            })
        })
    });
};
